import React from 'react'
import { Text } from '@moonpig/launchpad-components'

export const FormattedLocation = ({
  city,
  postcodes,
}: {
  city: string
  postcodes: string[]
}) => {
  return (
    <>
      <Text typography="typeBodyLabel">{city}</Text>
      {postcodes.length ? <>{` (${postcodes.join(', ')})`}</> : null}
    </>
  )
}
